import { type FC } from 'react';

// MUI
import TableContainer from '@mui/material/TableContainer';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';

// screen
import PdfPrintTitle from 'modules/map/components/pdf-print-form/PdfPrintTitle';
import { BalanceCostModel } from 'modules/map/components/balance-cost/types';
import PdfTableBody from 'modules/map/components/balance-cost/pdf/PdfTableBody';
import PdfFormNote from 'modules/map/components/pdf-print-form/styled-components/PdfFormNote';
import PrintThemeWrapper from 'modules/map/components/pdf-print-form/PrintThemeWrapper';
import { renderCell, sharedPrintTableStyles } from 'modules/map/components/pdf-print-form/utils';
import PdfTableHeader from 'modules/map/components/pdf-print-form/PdfTableHeader';

interface PdfBalanceCostProps {
  data: BalanceCostModel;
}

const PdfBalanceCost: FC<PdfBalanceCostProps> = ({ data }) => {
  const info = data?.structuredData?.data?.info;
  const showAfternoon = data.structuredData.metadata.hasAfternoon;

  const tableHeaders = [
    renderCell({ label: 'map.weekDayAndDate', rowSpan: 2 }),
    renderCell({ label: 'map.menu', rowSpan: 2, width: '18%' }),
    renderCell({ label: 'map.detail', rowSpan: 2, width: '17%' }),
    renderCell({ label: 'map.sl', rowSpan: 2 }),
    renderCell({ label: 'map.unit', rowSpan: 2 }),
    renderCell({ label: 'map.tt', rowSpan: 2 }),
    renderCell({ label: 'map.cooked', rowSpan: 2 }),
    renderCell({ label: 'map.extraFee', colSpan: 2 }),
    renderCell({
      label: showAfternoon ? 'map.afternoon' : 'map.note',
      rowSpan: 2,
    }),
    renderCell({ label: 'map.vat', rowSpan: 2 }),
    renderCell({ label: 'map.totalPrice', rowSpan: 2 }),
  ];

  const secondRows = [renderCell({ label: 'map.extraFee' }), renderCell({ label: 'map.price' })];

  return (
    <PrintThemeWrapper>
      <TableContainer className="px-2 tablet:px-4 space-y-4" sx={sharedPrintTableStyles}>
        <PdfPrintTitle
          title={info?.title || ''}
          subTitle={info?.mealPriceTitle || ''}
          week={info.weekTitle}
        />
        <Table sx={{ borderCollapse: 'separate' }}>
          <PdfTableHeader firstRow={tableHeaders} secondRow={secondRows} />
          <PdfTableBody data={data} />
        </Table>
        <Box sx={{ mt: 1 }}>
          <PdfFormNote
            content={'(Rau, canh có thể thay đổi theo mùa hoặc do điều kiện khách quan)'}
          />
        </Box>
      </TableContainer>
    </PrintThemeWrapper>
  );
};

export default PdfBalanceCost;
